import { createApi } from '@reduxjs/toolkit/query/react';
import { graphqlRequestBaseQuery } from '@rtk-query/graphql-request-base-query';
import { client } from 'graphql/client';
import { listHubs } from 'graphql/queries';
import { z } from 'zod';

import { errorHandler } from './errors';

import type { Hub } from 'API';
import { HubSchema } from 'APIzod';

export const hubsApi = createApi({
    reducerPath: 'hubs',
    baseQuery: graphqlRequestBaseQuery({
        url: '/graphql',
    }),
    refetchOnMountOrArgChange: true,
    endpoints: builder => ({
        listHubs: builder.query<Hub[], string>({
            queryFn: async () => {
                try {
                    const { data } = await client.graphql({ query: listHubs });
                    return { data: z.array(HubSchema()).parse(data.listHubs) };
                } catch (error) {
                    throw errorHandler('Unexpected error occurred while fetching the hubs', error);
                }
            },
        }),
    }),
});

export const { useListHubsQuery, useLazyListHubsQuery } = hubsApi;
